import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 12
  },
  paginationContainer: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: theme.palette.background.default,
    marginTop: 12,
    borderRadius: 12
  }
}))

export default useStyles
